import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const breadcrumbData = [
    { label: '首页', to: '/' },
    ...items,
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbData.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.to ? `https://guochanzx.com${item.to}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6">
        <ol className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
          {breadcrumbData.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
              )}
              {item.to && index < breadcrumbData.length - 1 ? (
                <Link
                  to={item.to}
                  className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={index === breadcrumbData.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string) {
  const category = categories.find((c) => c.slug === slug);
  return category ? [{ label: category.name, to: `/category/${slug}` }] : [];
}

export function getArticleBreadcrumb(categorySlug: string, articleTitle: string) {
  const category = categories.find((c) => c.slug === categorySlug);
  const items = [];
  if (category) {
    items.push({ label: category.name, to: `/category/${categorySlug}` });
  }
  items.push({ label: articleTitle });
  return items;
}